export const SocketKey = {
  inboxStatus: {
    general: 'inbox_status_updated',
    user: 'user_inbox_status_updated',
  },
  conversation: {
    conversationCreated: 'conversation_created',
    conversationUpdated: 'conversation_updated',
    statusChanged: 'conversation_status_changed',
    eventCreated: 'conversation_event_created',
    translated: 'conversation_event_translated',
    translationInProgress: 'conversation_event_translated_progress',
    deliveryStatusUpdated: 'message_delivery_status_updated',
  },
  knowledgeBase: {
    articleStateChanged: 'article_state_changed',
    retrainStateChanged: 'retrain_state_changed',
    knowledgeBaseUpdated: 'knowledge_base_updated',
    articleEmbedStateChanged: 'article_embed_state_changed',
    scrape: {
      itemUpdated: 'scrape_item_updated',
    },
  },
  actions: {
    httpRequestActionFromText: 'http_request_action_from_text',
  },
  simulation: {
    runProgress: 'simulation_run_progress',
  },
  onboarding: {
    fromUrlProgress: 'onboarding_from_url_progress',
  },
} as const;

type LeafValues<T> = T extends string | number | symbol
  ? T
  : { [K in keyof T]: LeafValues<T[K]> }[keyof T];

export type SocketEventName = LeafValues<typeof SocketKey>;
